<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header">
				<h1>{{ $t($route.name) }}</h1>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid">

		<div class="card" v-if="dataReady">
				<div class="card-block">
					<div class="row">
							<div class="col-sm-12">
								<ul class="timeline">
									<li v-for="(item, index) in records.items" :class="{'timeline-inverted': index % 2 === 0}" v-if="$config.basicLists.eventTypes[item.event_type]">
										<div class="timeline-badge" :class="$config.basicLists.eventTypes[item.event_type].color">
											<i class="fa" :class="$config.basicLists.eventTypes[item.event_type].icon"></i></div>
										<div class="timeline-panel">
												<div class="timeline-body">
												<p>
													<c-avatar :family="item.family" class="float-left"></c-avatar>
													<span>Семейство {{ item.family.name }}
													{{ $config.basicLists.eventTypes[item.event_type].text }}
													<router-link v-if="item.event_type !== 'new-family'"
													:to="$config.basicLists.eventTypes[item.event_type].link + item.target_id">
														{{ item.info.title }}
													</router-link>
													</span>
													<br>
													<span class="text-muted"><i class="fa fa-clock-o" :title="item.createdAt | prettyDateTime"></i> {{ item.createdAt | fromNowDateTime }}</span>
												</p>
												</div>
										</div>
									</li>
								</ul>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12">
						<f-pager :total="records.total" :clickhandler="pageClick"></f-pager>
					</div>
				</div>
			</div>

		</div><!--	end card	-->

	</div>
</div>
</template>

<script>

module.exports = {
	data: function () {
		return {
			records: {},
			dataReady: false
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function (pageNum) {
			pageNum = pageNum || 1;
			this.$http.get('backend://history?limit=' + this.$config.rpp + '&page=' + pageNum).then((result) => {
				this.records = result.body;
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		pageClick: function (pageNum) {
			this.fetchData(pageNum);
		}
	}
};
</script>



// WEBPACK FOOTER //
// Events.vue?6e28295e